import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05146344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "examination-info-wrap cm-form-info-grid" }
const _hoisted_2 = { class: "cm-form-item" }
const _hoisted_3 = { class: "cm-form-item" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_8 = { class: "cm-form-item" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "cm-form-item" }
const _hoisted_11 = { class: "cm-form-item" }
const _hoisted_12 = { class: "cm-form-item" }
const _hoisted_13 = { class: "cm-form-item" }
const _hoisted_14 = { class: "cm-form-item" }
const _hoisted_15 = { class: "cm-form-item" }
const _hoisted_16 = { class: "header cm-ui-ml15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExaminationDetail = _resolveComponent("ExaminationDetail")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('listColumns.lastExamTime')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.formatTimeStamp(_ctx.compData.examination_time) || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('listColumns.examStatus')), 1),
      (_ctx.compData.physical_exam_status === 3 || _ctx.compData.physical_exam_status === 4)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            (_ctx.isLong(_ctx.compData.examination_time))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examOverdueNoExam')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.statusNameMap[_ctx.compData.physical_exam_status]), 1))
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.statusNameMap[_ctx.compData.physical_exam_status]), 1)
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('listColumns.lastExamScore')), 1),
      (_ctx.compData.physical_exam_status === 3)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "cm-link-light",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDetailVisible = true))
          }, _toDisplayString(_ctx.compData.score), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_9, "--"))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examCatSpeed')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examIssueCount', { n: _ctx.compData.exam_detail?.speed?.count || 0 })), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examCatSystem')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examIssueCount', { n: _ctx.compData.exam_detail?.system?.count || 0 })), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examCatVirus')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examIssueCount', { n: _ctx.compData.exam_detail?.virus?.count || 0 })), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examCatGarbage')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examIssueCount', { n: _ctx.compData.exam_detail?.garbage?.count || 0 })), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examCatGuard')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examIssueCount', { n: _ctx.compData.exam_detail?.guard?.count || 0 })), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examCatSoft')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examIssueCount', { n: _ctx.compData.exam_detail?.soft?.count || 0 })), 1)
    ]),
    _createVNode(_component_el_drawer, {
      size: "45%",
      modelValue: _ctx.isDetailVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDetailVisible) = $event)),
      direction: "rtl",
      "custom-class": "exam-detail-wrapper",
      "destroy-on-close": ""
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.examDetailDrawerTitle')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ExaminationDetail, {
          "base-info": { ..._ctx.compData, device_id: _ctx.deviceId },
          "group-id": _ctx.compData.group_id,
          onCloseDrawer: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDetailVisible = false))
        }, null, 8, ["base-info", "group-id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}